/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API20969Req {
  
  /** 排序资源 ,String */
  resourceIdList?: any[];
};



export interface API20969Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 20969 删除常用功能

export interface IUsePostAPI20969Return {
  /** 删除常用功能: 接口请求状态 */
  isAPI20969Loading: boolean;
  /** 删除常用功能: 接口请求返回数据 */
  dataAPI20969: API20969Res;
  /**  删除常用功能: 接口数据请求方法 */
  fetchAPI20969Data:  (inputs: API20969Req, config?: YWRequestConfig) => Promise<API20969Res>;
  /** 删除常用功能: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI20969 = ():IUsePostAPI20969Return => {
  let isMount = true;
  const [isAPI20969Loading, setIsAPI20969Loading] = useState(false);
  const [dataAPI20969, setDataAPI20969] = useState<API20969Res>({} as API20969Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/home/common/function/delete`;

  const fetchAPI20969Data = async (inputs: API20969Req, config?: YWRequestConfig): Promise<API20969Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20969Req>) || {}) as API20969Req;
    
  
    if ( isMount ) {
      setIsAPI20969Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API20969Res>(`${basePath}/ywwl-admin/desktop/home/common/function/delete`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI20969(res || {} as API20969Res);
        setIsAPI20969Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20969Loading(false);
      }
      return false as unknown as API20969Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20969Loading,
    dataAPI20969,
    fetchAPI20969Data,
    requestUrl,
  }
}

